import { gql } from "@shane32/graphql";

export const FeedbackNameQuery = gql`
    {
        v1 {
            my {
                feedbackName
            }
        }
    }
`;

export interface IFeedbackNameQuery {
    v1: {
        my: {
            feedbackName: string;
        } | null;
    };
}

export interface IFeedbackNameQueryVariables {}
